import {
  selectAppData,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import { useCallback } from "react";
import { APP_DATA } from "../../common/constants";

export const usePinnerPeer = () => {
  return useHMSStore(selectAppData(APP_DATA.pinnedPeer));
};

export const useSetPinnedPeer = () => {
  const hmsActions = useHMSActions();
  return useCallback(
    peerId => {
      hmsActions.setAppData(APP_DATA.pinnedPeer, peerId);
    },
    [hmsActions]
  );
};
